function AppEnv() {
	const data = {
		...(window.appEnvironment || {
			platform: 'android',
			appName: 'fk-cp-selfserve'
		})
	};

	return Object.freeze(data);
}

export default AppEnv();
